module.exports = __webpack_public_path__ + "static/media/call_animation.8e8b993e.gif";